"use client";
import {
  Box,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { SectionTemplate } from "components/individuals/blocks";
import { customRichText } from "./individuals/mdx-components";

export interface ProductPitchSectionProps {
  title: string;
  additionalText: string;
  content: any;
  bg: string;
  subtitleColor: string;
  titleColor: string;
}

export const ProductPitchSection = ({
  title,
  additionalText,
  content,
  bg,
  subtitleColor,
  titleColor,
}: ProductPitchSectionProps) => {
  return (
    <SectionTemplate
      bg={bg}
      fontSize={{
        base: 18,
        md: 20,
        lg: 24,
        xl: 30,
      }}
      fontWeight={"bold"}
      textAlign="center"
    >
      <MobileProductPitchSection
        title={title}
        additionalText={additionalText}
        content={content.raw}
        subtitleColor={subtitleColor}
        titleColor={titleColor}
      />
      <DesktopProductPitchSection
        title={title}
        additionalText={additionalText}
        content={content.raw}
        subtitleColor={subtitleColor}
        titleColor={titleColor}
      />
    </SectionTemplate>
  );
};

const DesktopProductPitchSection = ({
  title,
  additionalText,
  content,
  subtitleColor,
  titleColor,
}: Omit<ProductPitchSectionProps, "bg">) => {
  return (
    <Box
      display={{
        base: "none",
        lg: "block",
      }}
      w={{
        base: "90%",
        md: "80%",
      }}
      mx="auto"
    >
      <Text color={titleColor} mb={6}>
        {title}
      </Text>
      <RichText
        renderers={customRichText(subtitleColor, 0, 6, {
          lg: "24px",
          xl: "30px",
        })}
        content={content}
      />
      <Text color={titleColor}>{additionalText}</Text>
    </Box>
  );
};

const MobileProductPitchSection = ({
  title,
  additionalText,
  content,
  subtitleColor,
  titleColor,
}: Omit<ProductPitchSectionProps, "bg">) => {
  return (
    <Box
      display={{
        base: "block",
        lg: "none",
      }}
      textAlign={"left"}
    >
      <Text
        color={titleColor}
        mb={{
          base: 4,
          lg: 6,
        }}
      >
        {title}
      </Text>

      <RichText
        renderers={customRichText(subtitleColor, 0, 0, {
          base: "18px",
          md: "20px",
        })}
        content={content}
      />

      <Accordion color={titleColor} allowToggle>
        <AccordionItem border="none">
          <AccordionButton w="fit" mx="auto">
            <Box as="span" fontSize={"2xl"}>
              ...
            </Box>
          </AccordionButton>

          <AccordionPanel pb={4} px={0}>
            <Text
              color={titleColor}
              mb={{
                base: 4,
                lg: 8,
              }}
            >
              {additionalText}
            </Text>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  );
};
